import { useStaticQuery, graphql } from 'gatsby';
import { getImage } from 'gatsby-plugin-image';

const QUERY = graphql`
  query {
    images: allFile(
      filter: { absolutePath: { regex: "//featured/" } }
      sort: { fields: [name], order: ASC }
    ) {
      edges {
        node {
          extension
          relativePath
          childImageSharp {
            gatsbyImageData(
              formats: [AUTO, WEBP]
              quality: 30
              breakpoints: [300, 720]
              placeholder: BLURRED
              backgroundColor: "transparent"
              transformOptions: { grayscale: true }
            )
          }
        }
      }
    }
  }
`;

const GetFeatured = () => {
  const { images } = useStaticQuery(QUERY);
  return images.edges;
};

const featured = (imageFileName) => {
  const data = GetFeatured();
  const img = imageFileName
    ? data.find(
        (image) =>
          image.node.relativePath.replace(/\.[^/.]+$/, '').toLowerCase() ===
          imageFileName.toLowerCase(),
      )
    : null;

  return img ? getImage(img.node) : '';
};

export default featured;
